import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { CHECK_EXERCISE, EXERCISE_ENTITY_UPDATED, SET_ANSWERS, SET_CHOICE, SHOW_EXERCISE, UPDATE_LOST_XP } from '../actions/types';
import { getLastMultipleChoiceAnswer } from '../lib/getLastAnswer';
const initialState = {};
const defaults = {
  lostXp: 0,
  solutionShown: 0
};
export default (function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case CHECK_EXERCISE:
      {
        const lastSubmission = {
          message: action.message,
          submittedCode: action.lastSubmittedCode,
          success: action.success
        };
        return _objectSpread(_objectSpread({}, state), {}, {
          [action.id]: _objectSpread(_objectSpread({}, state[action.id]), {}, {
            lastSubmission
          })
        });
      }
    case SHOW_EXERCISE:
      return _objectSpread(_objectSpread({}, state), {}, {
        [action.id]: _objectSpread(_objectSpread({}, defaults), state[action.id])
      });
    case UPDATE_LOST_XP:
      return _objectSpread(_objectSpread({}, state), {}, {
        [action.exerciseId]: _objectSpread(_objectSpread(_objectSpread({}, defaults), state[action.exerciseId]), {}, {
          lostXp: action.lostXp
        })
      });
    case SET_CHOICE:
      return _objectSpread(_objectSpread({}, state), {}, {
        [action.exerciseId]: _objectSpread(_objectSpread({}, state[action.exerciseId]), {}, {
          currentChoice: action.currentChoice
        })
      });
    case SET_ANSWERS:
      return _objectSpread(_objectSpread({}, state), {}, {
        [action.exerciseId]: _objectSpread(_objectSpread({}, state[action.exerciseId]), {}, {
          currentAnswers: action.currentAnswers
        })
      });
    case EXERCISE_ENTITY_UPDATED:
      {
        const lastAttempt = getLastMultipleChoiceAnswer(action.exerciseEntity);
        return _objectSpread(_objectSpread({}, state), {}, {
          [action.exerciseId]: _objectSpread(_objectSpread({}, state[action.exerciseId]), {}, {
            currentChoice: lastAttempt != null ? lastAttempt - 1 : 0
          })
        });
      }
    default:
      return state;
  }
});